export default __webpack_public_path__ + "static/linkedin-1bff5ccb29d6fdbdf75553cd4803dcaf.svg";